import { CHAT_CONFIG, SYSTEM_PROMPT } from '../constants/chatConfig';

export const useOpenAI = () => {
  const callOpenAI = async (userMessage, conversationContext, userInfo) => {
    try {
      const systemPromptWithInfo = `${SYSTEM_PROMPT}

Aktuell gesammelte Informationen über den Kunden:
${Object.entries(userInfo).map(([key, value]) => value ? `${key}: ${value}` : '').filter(Boolean).join('\n')}`;

      const response = await fetch('https://api.openai.com/v1/chat/completions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${CHAT_CONFIG.OPENAI_API_KEY}`
        },
        body: JSON.stringify({
          model: CHAT_CONFIG.MODEL,
          messages: [
            {
              role: 'system',
              content: systemPromptWithInfo
            },
            ...conversationContext,
            {
              role: 'user',
              content: userMessage
            }
          ],
          max_tokens: CHAT_CONFIG.MAX_TOKENS,
          temperature: CHAT_CONFIG.TEMPERATURE,
          presence_penalty: CHAT_CONFIG.PRESENCE_PENALTY,
          frequency_penalty: CHAT_CONFIG.FREQUENCY_PENALTY
        })
      });

      if (!response.ok) {
        throw new Error(`OpenAI API error: ${response.status}`);
      }

      const data = await response.json();
      return data.choices[0].message.content;
    } catch (error) {
      console.error('OpenAI API Error:', error);
      return "Entschuldigung, ich hatte gerade einen kleinen technischen Fehler. Kannst Du Deine Nachricht bitte wiederholen?";
    }
  };

  const extractUserInfo = async (conversation) => {
    try {
      const extractionPrompt = `Analysiere das folgende Gespräch und extrahiere die Kundeninformationen. Antworte nur mit einem JSON-Objekt:

Gespräch: ${conversation.map(msg => `${msg.role}: ${msg.content}`).join('\n')}

Extrahiere diese Informationen (nur wenn explizit erwähnt):
{
  "name": "",
  "email": "",
  "phone": "",
  "projectType": "",
  "budget": "",
  "timeline": "",
  "location": "",
  "details": ""
}`;

      const response = await fetch('https://api.openai.com/v1/chat/completions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${CHAT_CONFIG.OPENAI_API_KEY}`
        },
        body: JSON.stringify({
          model: 'gpt-3.5-turbo',
          messages: [
            {
              role: 'user',
              content: extractionPrompt
            }
          ],
          max_tokens: 200,
          temperature: 0.1
        })
      });

      if (response.ok) {
        const data = await response.json();
        try {
          return JSON.parse(data.choices[0].message.content);
        } catch (parseError) {
          console.log('Could not parse extracted info:', parseError);
          return {};
        }
      }
      return {};
    } catch (error) {
      console.error('Info extraction error:', error);
      return {};
    }
  };

  return { callOpenAI, extractUserInfo };
};
